// extracted by mini-css-extract-plugin
export default {"container":"UHqfb1UjQ2Z8-Iff2YTULw==","description":"_2s1T7XjLzNdRZctZ-+lLEg==","loginButton":"cEyYeU6mH9UTYKNylMrnSg=="};